"use client";

import { ButtonNova } from "@/components/ui-kit/ButtonNova/ButtonNova";
import Picture from "@/components/ui-kit/Picture/Picture";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { useNavigation } from "@/hooks/useNavigation";
import { GA4 } from "@/utils/ga4Utils";
import { cn } from "@/utils/general";

const quizUrl = "/hair/brand/quiz/";
const buttonLabel = "Take the quiz";

const RggMenNavBanner2 = ({ className }: { className?: string }) => {
  const navigate = useNavigation();

  const handleOnClick = () => {
    GA4.onMarketingCtaClicked({
      destination: quizUrl,
      module_location: "navigation",
      text: buttonLabel,
      type: "banner",
    });

    navigate(quizUrl);
  };

  return (
    <div
      className={cn(
        "bg-cover bg-center bg-no-repeat",
        "bg-[url('https://images.ctfassets.net/0rbfqd9c4jdo/oYAQP1nRM1cgIPGovcyeo/f0997f2edab2316e2771dc8084ef1223/rgg-men-hp-banner-mobile__1_.jpg')]",
        "md:bg-[url('https://images.ctfassets.net/0rbfqd9c4jdo/2A8ZIN6r3BfuBW1HBxfPFc/d91d5afa6cf3d0f57d4960f83d57933d/RGG_Nav_Banner-men-tablet.jpg')]",
        "lg:bg-[url('https://images.ctfassets.net/0rbfqd9c4jdo/3LzRzJWxLmhFqJVJC6qE7e/ad7857097f83eab26199838050290fdd/mens-nav-rgg-desktop.jpg')]",
        "cursor-pointer rounded h-[119px] md:h-full md:w-full md:max-w-[279px] lg:max-w-[356px]",
        className
      )}
      onClick={handleOnClick}
    >
      <div className="h-full w-full flex justify-center md:p-6">
        <div className="flex md:flex-col items-center justify-center md:justify-between">
          <TextElementNova
            text="Results in 6 months or your<br class='hidden xl:block' /> money back.<sup>∞</sup>"
            className="Body-30-Dia-Strong text-nova-base-white hidden md:block text-center"
          />
          <div className="flex-shrink-0 w-[103px] h-[103px] md:w-[206px] md:h-[206px] xl:h-[268px] xl:w-[268px]">
            <Picture
              src="https://images.ctfassets.net/0rbfqd9c4jdo/1yq2Qrbvad7ekKWktqf9fP/7dd5cac96f2e4c623c767d13247af30d/RGG_Badge.png"
              alt="Nutrafol Real Growth Guarantee. Results or Refund."
            />
          </div>
          <div className="flex flex-col gap-2 items-start">
            <TextElementNova
              text="Results in 6 months or<br class='md:hidden' /> your money back.<sup>∞</sup>"
              className="Body-30-Dia-Strong text-nova-base-white md:hidden"
            />
            <div className="hidden xl:block">
              <ButtonNova
                label="Take the quiz for a personalized plan"
                icon="Right"
                level="Tertiary"
                copyClassName="text-nova-base-white"
                tabIndex={-1}
                aria-hidden="true"
              />
            </div>
            <div className="xl:hidden">
              <ButtonNova
                label={buttonLabel}
                icon="Right"
                level="Tertiary"
                copyClassName="text-nova-base-white"
                tabIndex={-1}
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RggMenNavBanner2;
